export default (req) => ({
  createPromotionFromGoogleSheet: () =>
    req.post("/sheet/management/createpromotions"),
  updateGoogleSheet: () => req.put("/sheet/management/update"),
  createinventoryreport: () =>
    req.post("/sheet/management/createinventoryreport"),
});
